import { render, staticRenderFns } from "./GridQuestionnaire.vue?vue&type=template&id=552d71f4&scoped=true"
import script from "./GridQuestionnaire.vue?vue&type=script&setup=true&lang=js"
export * from "./GridQuestionnaire.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GridQuestionnaire.vue?vue&type=style&index=0&id=552d71f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552d71f4",
  null
  
)

export default component.exports